<template>
    <div id="content">
        <div class="container">
            <div class="card" style="height: calc(100vh - 190px);">
                <div class="card-header d-flex align-items-center gap-3">
                    <div class="card-title d-flex align-items-center gap-2">{{ $t('leaderboard') }}<span v-if="filter.week">{{ `(${$t('week')} ${filter.week.weekIndex}: ${moment(filter.week.start).format("DD/MM")} ${$t('to')}
                            ${moment(filter.week.end).format("DD/MM")})` }}</span></div>
                    <div class="ms-auto d-flex gap-3">
                        <!-- <button class="btn" :class="[filter.type === 1 ? 'btn-info' : 'btn-light']" @click="filter.type = 1">{{ $t('by_week') }}</button> -->
                        <!-- <button class="btn" :class="[filter.type === 2 ? 'btn-info' : 'btn-light']" @click="filter.type = 2">{{ $t('by_month') }}</button> -->

                        <week-picker v-model="filter.week" :startDate="$store.state.user_info.contest_info.start_time" :endDate="$store.state.user_info.contest_info.end_time" :placeholder="$t('choose_week')" v-if="filter.type === 1" />

                        <!-- <month-picker v-model="filter.month" v-if="filter.type === 2" /> -->
                    </div>
                </div>
                <div class="card-body d-flex flex-column gap-3 p-3">
                    <div class="d-flex align-items-center justify-content-between gap-3 w-100">
                        <div class="d-flex align-items-center gap-3">
                            <button class="btn d-flex gap-2 align-items-center" :class="[filter.limit_by === 1 ? 'btn-info' : 'btn-light']" @click="filter.limit_by = 1">
                                <svg class="icon-global" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M17.3122 13.5401C17.8341 12.4629 18.1115 11.2837 18.1245 10.0868C18.1376 8.88995 17.8859 7.70497 17.3877 6.61667C16.8894 5.52836 16.1567 4.56362 15.2422 3.79144C14.3276 3.01927 13.2537 2.45874 12.0972 2.14996C12.0832 2.14558 12.0689 2.1418 12.0546 2.13841C10.7859 1.8071 9.45586 1.78804 8.17821 2.08286C6.90055 2.37768 5.71333 2.97761 4.7181 3.83133C4.68002 3.85775 4.64502 3.88836 4.61376 3.92258C3.37918 5.01526 2.5064 6.45781 2.11146 8.05849C1.71651 9.65916 1.81811 11.3421 2.40274 12.8837C2.98736 14.4252 4.02733 15.7523 5.38439 16.6885C6.74145 17.6248 8.35132 18.1258 10 18.125C10.0575 18.125 10.1147 18.124 10.172 18.1228C10.1734 18.1228 10.1748 18.123 10.1762 18.123C10.1789 18.123 10.1815 18.1227 10.1843 18.1227C11.6598 18.0878 13.0982 17.6522 14.3451 16.8625C15.592 16.0727 16.6006 14.9586 17.2628 13.6395L17.2639 13.6378C17.2829 13.6067 17.299 13.574 17.3122 13.5401ZM16.875 10C16.8757 10.8191 16.7293 11.6316 16.4429 12.3989L12.8178 10.1694C12.6693 10.0778 12.5031 10.0185 12.3301 9.99543L10.5474 9.7551C10.3182 9.72538 10.0853 9.75933 9.87413 9.85324C9.66298 9.94715 9.48177 10.0974 9.35036 10.2875H8.68294L8.3857 9.67339C8.30288 9.5023 8.18214 9.35234 8.03266 9.23492C7.88318 9.11751 7.70889 9.03572 7.52305 8.99579L7.01012 8.88558L7.20679 8.41866C7.25453 8.30532 7.33465 8.20859 7.4371 8.14057C7.53956 8.07255 7.6598 8.03627 7.78278 8.03627H9.03549C9.24683 8.03616 9.4547 7.98257 9.63974 7.88048L10.5962 7.3523C10.6804 7.3058 10.759 7.24976 10.8303 7.18529L12.9327 5.28389C13.1139 5.12123 13.2434 4.90891 13.305 4.67331C13.3665 4.4377 13.3575 4.1892 13.2791 3.95866C14.3662 4.54934 15.274 5.42222 15.9069 6.4854C16.5397 7.54859 16.8741 8.76273 16.875 10ZM3.125 10C3.12378 8.92325 3.37704 7.86145 3.86414 6.90117L4.67846 9.07464C4.75157 9.2711 4.87311 9.44592 5.03182 9.58288C5.19053 9.71983 5.38126 9.81447 5.58632 9.85802L6.017 9.9506L6.02055 9.95137L6.96224 10.1538C7.05514 10.1738 7.14225 10.2146 7.21697 10.2733C7.29169 10.332 7.35205 10.407 7.39345 10.4925L7.55786 10.8321C7.6602 11.0435 7.82002 11.2218 8.01901 11.3466C8.218 11.4713 8.44811 11.5375 8.68298 11.5375H8.76961L8.16841 12.8865C8.0687 13.1098 8.03677 13.3575 8.07658 13.5988C8.11639 13.8402 8.22618 14.0645 8.39234 14.2439L9.64624 15.6002C9.71283 15.6722 9.76152 15.7589 9.7884 15.8532C9.81528 15.9475 9.81958 16.0469 9.80095 16.1432L9.66103 16.8666C7.89922 16.7775 6.23884 16.0155 5.0226 14.7377C3.80636 13.46 3.12709 11.7641 3.125 10Z"
                                        :fill="filter.limit_by === 1 ? '#FFFFFF' : '#98C93C'" />
                                </svg>
                                <span>{{ $t('all_users') }}</span>
                            </button>
                            <button class="btn d-flex gap-2 align-items-center" :class="[filter.limit_by === 2 ? 'btn-info' : 'btn-light']" @click="filter.limit_by = 2">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.625 17.5H11.7609C12.411 16.9205 13.0242 16.3008 13.5966 15.6445C15.7413 13.178 16.875 10.5779 16.875 8.125C16.875 6.30164 16.1507 4.55295 14.8614 3.26364C13.572 1.97433 11.8234 1.25 10 1.25C8.17664 1.25 6.42795 1.97433 5.13864 3.26364C3.84933 4.55295 3.125 6.30164 3.125 8.125C3.125 10.5779 4.25865 13.178 6.40335 15.6445C6.97585 16.3008 7.58896 16.9205 8.23908 17.5H4.375C4.20924 17.5 4.05027 17.5658 3.93306 17.6831C3.81585 17.8003 3.75 17.9592 3.75 18.125C3.75 18.2908 3.81585 18.4497 3.93306 18.5669C4.05027 18.6842 4.20924 18.75 4.375 18.75H15.625C15.7908 18.75 15.9497 18.6842 16.0669 18.5669C16.1842 18.4497 16.25 18.2908 16.25 18.125C16.25 17.9592 16.1842 17.8003 16.0669 17.6831C15.9497 17.5658 15.7908 17.5 15.625 17.5ZM10 5.625C10.4945 5.625 10.9778 5.77162 11.3889 6.04633C11.8001 6.32103 12.1205 6.71148 12.3097 7.16829C12.4989 7.62511 12.5484 8.12777 12.452 8.61273C12.3555 9.09768 12.1174 9.54314 11.7678 9.89277C11.4182 10.2424 10.9727 10.4805 10.4877 10.577C10.0028 10.6734 9.50013 10.6239 9.04331 10.4347C8.5865 10.2455 8.19605 9.92505 7.92135 9.51393C7.64664 9.1028 7.50002 8.61945 7.50002 8.125C7.50002 7.79669 7.56468 7.4716 7.69031 7.16829C7.81595 6.86497 8.0001 6.58937 8.23225 6.35723C8.46439 6.12508 8.73999 5.94093 9.04331 5.8153C9.34662 5.68966 9.67171 5.625 10 5.625Z"
                                        :fill="filter.limit_by === 2 ? '#FFFFFF' : '#FF0000'" />
                                </svg>
                                <span>{{ $t('zone') }}</span>
                            </button>
                        </div>

                        <div class="d-flex flex-column align-items-end" v-if="filter.limit_by === 2">
                            <p class="m-0 fs-10">{{ `${user_info.province.name} - ${user_info.ward.name}` }}</p>
                            <p class="m-0 fs-14 fw-bold">{{ `Thuộc ${$t(userZone.name)}` }}</p>
                        </div>
                    </div>
                    <leader-board-items class="flex-fill" :data="data" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from 'moment';
import { filter } from 'lodash';
import { getContestLeaderboard } from "@/models/leadboard";

import WeekPicker from '../common/WeekPicker.vue';
import MonthPicker from '../common/MonthPicker.vue';
import LeaderBoardItems from './LeaderBoardItems.vue';

export default {
    name: "LeaderBoardContest",
    title: 'Leaderboard',
    components: { WeekPicker, MonthPicker, LeaderBoardItems },

    data() {
        return {
            filter: {
                type: 1,
                limit_by: 1,
                week: null,
                month: null
            },

            data: {
                leaderboard: [],
                my_rank: null,
            }
        };
    },

    computed: {
        user_info() {
            return this.$store.state.user_info;
        },

        userZone() {
            const user_info = this.$store.state.user_info
            return user_info.contest_info.user_zone
        },

        configs() {
            return this.$store.state.configs
        },
    },

    watch: {
        filter: {
            handler() {
                this.fetch()
            },
            deep: true
        }

    },

    created() {
        this.$store.commit("setMenuActive", "home");
    },

    methods: {
        moment,
        fetch() {
            if (!this.filter.week) return;
            this.$store.commit("setLoading", true);
            axios.all([
                getContestLeaderboard({
                    contest_id: this.user_info.contest_info.id,
                    start_date: moment(this.filter.week?.start).format("YYYY-MM-DD HH:mm:ss"),
                    end_date:
                        moment(this.filter.week?.end)
                            .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
                            .format("YYYY-MM-DD HH:mm:ss")
                    ,
                    zone_id: this.filter.limit_by == 1 ? 0 : this.userZone.id
                }),
            ]).then(axios.spread((response) => {
                this.$store.commit("setLoading", false);

                // if (response.data.code != 0) {
                //     return;
                // }

                this.data = response.data;
            }));
        },
    }
}
</script>

<style scoped>
.fs-10 {
    font-size: 10px;
    color: #000000;
}

.fs-14 {
    font-size: 14px;
    color: #000000;
}

.card-title {
    margin: 0;
    font-weight: bold;
    font-size: 20px;
}

.card-title span {
    font-weight: normal;
    font-size: 14px;
}

.btn {
    border-radius: 5px;
    box-shadow: none;
}

.btn-light {
    border: 1px solid #DADADA;
    color: #000000;
    font-weight: 700;
    background: #FFFFFF;
}

.btn-info {
    color: #FFFFFF;
    font-weight: 700;
    background: #00A3FFD1;
}
</style>